/* eslint-disable no-unused-vars */
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import MobileMenu from '../MobileMenu/MobileMenu'
import Logo from '../../images/logo.png'
import HeaderTopbar from '../HeaderTopbar/HeaderTopbar'
import { useLanguage } from '../../i18n/LanguageContext'


const Header = (props) => {

    const [menuActive, setMenuState] = useState(false);
    const { t } = useLanguage();
    const SubmitHandler = (e) => {
        e.preventDefault()
    }

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <header id="header">
            <HeaderTopbar topbarClass={props.topbarClass}/>
            <div className={`wpo-site-header ${props.hclass}`}>
                <nav className="navigation navbar navbar-expand-lg navbar-light">
                    <div className="container-fluid">
                        <div className="row align-items-center">
                            <div className="col-lg-3 col-md-4 col-3 d-lg-none dl-block">
                                <div className="mobail-menu">
                                    <MobileMenu />
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-4 col-6">
                                <div className="navbar-header">
                                    <Link onClick={ClickHandler} className="navbar-brand" to="/home-5"><img src={Logo}
                                        alt="logo" /></Link>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-1 col-1">
                                <div id="navbar" className="collapse navbar-collapse navigation-holder">
                                    <button className="menu-close"><i className="ti-close"></i></button>
                                    <ul className="nav navbar-nav mb-2 mb-lg-0">
                                        <li className="menu-item-has-children">
                                            <Link onClick={ClickHandler} to="/home-5">{t('nav.home')}</Link>
                                            {/* <ul className="sub-menu">
                                                <li><Link onClick={ClickHandler} to="/home">Home Style 1</Link></li>
                                                <li><Link onClick={ClickHandler} to="/home-2">Home Style 2</Link></li>
                                                <li><Link onClick={ClickHandler} to="/home-3">Home Style 3</Link></li>
                                                <li><Link onClick={ClickHandler} to="/home-4">Home Style 4</Link></li>
                                                <li><Link onClick={ClickHandler} to="/home-5">Home Style 5</Link></li>
                                            </ul> */}
                                        </li>
                                        {/* <li><Link onClick={ClickHandler} to="/about">「ボラボラ」</Link></li> */}
                                        <li className="menu-item-has-children">
                                            <Link onClick={ClickHandler} to="">{t('nav.volunteer')}</Link>
                                            <ul className="sub-menu">
                                                <li><Link onClick={ClickHandler} to="/teacher">{t('nav.teachers')}</Link></li>
                                                <li><Link onClick={ClickHandler} to="/become-teacher">{t('nav.volunteerRecruitment')}</Link></li>
                                                {/* <li><Link onClick={ClickHandler} to="/course-3">Courses Style 3</Link></li>
                                                <li><Link onClick={ClickHandler} to="/course-single/Learn-WordPress-&-Elementor-for-Beginners">Courses single</Link></li> */}
                                            </ul>
                                        </li>
                                        <li className="menu-item-has-children">
                                            <Link onClick={ClickHandler} to="/home">{t('nav.japaneseClass')}</Link>
                                            {/* <ul className="sub-menu">
                                                <li><Link onClick={ClickHandler} to="/lesson">Lesson</Link></li>
                                                <li><Link onClick={ClickHandler} to="/gallery">Gallery</Link></li>
                                                <li><Link onClick={ClickHandler} to="/testimonial">Testimonial</Link></li>
                                                <li><Link onClick={ClickHandler} to="/teacher">Teachers</Link></li>
                                                <li><Link onClick={ClickHandler} to="/team-single/Courtney-Henry">Teacher Single</Link></li>
                                                <li><Link onClick={ClickHandler} to="/become-teacher">Become Teacher</Link></li>
                                                <li><Link onClick={ClickHandler} to="/faq">FAQ</Link></li>
                                                <li><Link onClick={ClickHandler} to="/404">404 Error</Link></li>
                                            </ul> */}
                                        </li>
                                        <li className="menu-item-has-children">
                                            <Link onClick={ClickHandler} to="">{t('nav.cookingClass')}</Link>
                                            <ul className="sub-menu">
                                                <li><Link style={{ textDecoration: 'line-through' }} to="">{t('nav.nextCookingClass')}</Link></li>
                                                <li><Link onClick={ClickHandler} to="/home-3">{t('nav.pastCookingClasses')}</Link></li>
                                                {/* <li><Link onClick={ClickHandler} to="/blog-fullwidth">Blog fullwidth</Link></li>
                                                <li className="menu-item-has-children">
                                                    <Link onClick={ClickHandler} to="/">Blog details</Link>
                                                    <ul className="sub-menu">
                                                        <li><Link onClick={ClickHandler} to="/blog-single/Become-a-great-WordPress-&-PHP-developer.">Blog details right sidebar</Link>
                                                        </li>
                                                        <li><Link onClick={ClickHandler} to="/blog-single-left-sidebar/Become-a-great-WordPress-&-PHP-developer.">Blog details left
                                                            sidebar</Link></li>
                                                        <li><Link onClick={ClickHandler} to="/blog-single-fullwidth/Become-a-great-WordPress-&-PHP-developer.">Blog details
                                                            fullwidth</Link></li>
                                                    </ul>
                                                </li> */}
                                            </ul>
                                        </li>
                                        <li className="menu-item-has-children">
                                            <Link onClick={ClickHandler} to="/event">{t('nav.events')}</Link>
                                            {/* <ul className="sub-menu">
                                                <li><Link onClick={ClickHandler}style={{ textDecoration: 'line-through' }} to="">最新イベント</Link></li>
                                                <li><Link onClick={ClickHandler}  to="/event">イベント履歴</Link></li>
                                                <li><Link onClick={ClickHandler} to="/cart">Cart</Link></li>
                                                <li><Link onClick={ClickHandler} to="/checkout">Checkout</Link></li>
                                            </ul> */}
                                        </li>
                                        <li><Link onClick={ClickHandler} to="/contact">{t('nav.contact')}</Link></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-2">
                                <div className="header-right">
                                    <div className="header-search-form-wrapper">
                                        {/* <div className="cart-search-contact">
                                            <button onClick={() => setMenuState(!menuActive)} className="search-toggle-btn"><i
                                                className={`fi ti-search ${menuActive ? "ti-close" : "fi "}`}></i></button>
                                            <div className={`header-search-form ${menuActive ? "header-search-content-toggle" : ""}`}>
                                                <form onSubmit={SubmitHandler}>
                                                    <div>
                                                        <input type="text" className="form-control"
                                                            placeholder="Search here..." />
                                                        <button type="submit"><i
                                                            className="fi flaticon-search"></i></button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div> */}
                                          <a onClick={ClickHandler} className="theme-btn" href="https://lin.ee/Xu9Rd8F"><span className="text">{t('nav.addLineFriend')}</span>
                                            <span className="mobile">
                                                <i className="fi flaticon-charity"></i>
                                            </span></a> 
                                
                                    </div>
                                    {/* <div className="close-form">
                                        <Link onClick={ClickHandler} className="login" to="/login"><span className="text">Sign In</span>
                                            <span className="mobile">
                                                <i className="fi flaticon-charity"></i>
                                            </span></Link>
                                        <Link onClick={ClickHandler} className="theme-btn" to="/register"><span className="text">Sign Up</span>
                                            <span className="mobile">
                                                <i className="fi flaticon-charity"></i>
                                            </span></Link>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </header>
    )
}

export default Header;
